(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      // KOPFZEILE OHNE RUECKKOPPLUNG: Hoehensprung des Untertitels messen - jetzt, nach
      // dem Laden der Bilder (der Untertitel ist ein Bild) und bei jeder Groessenaenderung.
      this.einklappSprung = 0;
      this.messeEinklappen();
      window.addEventListener('load', () => this.messeEinklappen());
      this.header.querySelectorAll('.header__subtitle img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.messeEinklappen(), { once: true });
      });
      let messRahmen = 0;
      window.addEventListener('resize', () => {
        cancelAnimationFrame(messRahmen);
        messRahmen = requestAnimationFrame(() => this.messeEinklappen());
      });

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    // Misst, wie viel niedriger die Kopfzeile eingeklappt ist, und schreibt das als
    // --untertitel-platz (Ausgleich im Seitenfluss) sowie --untertitel-h (animierbare Hoehe).
    // Gemessen wird die Kopfzeile selbst in beiden Zustaenden, nicht Bild + Abstand einzeln:
    // So stimmt der Wert auch dann, wenn eine Media Query Abstaende oder Bildgroesse aendert.
    // Beide Zustaende werden synchron hintereinander gelesen - der Browser malt dazwischen
    // nicht, sichtbar ist davon nichts. Uebergaenge und Scroll Anchoring sind waehrenddessen
    // aus (base.css, .kopf-messung).
    messeEinklappen() {
      const h = this.header;
      const sub = h.querySelector('.header__subtitle');
      if (!sub) return;
      const warKompakt = h.classList.contains('header-compact');
      document.documentElement.classList.add('kopf-messung-aktiv');
      h.classList.add('kopf-messung');
      sub.style.removeProperty('height');
      h.classList.remove('header-compact');
      h.style.setProperty('--untertitel-h', 'auto');
      // getBoundingClientRect statt offsetHeight: offsetHeight rundet auf ganze Pixel. Bei
      // 852x393 ist der Sprung 27,9px - gerundet blieb ein Zehntel Pixel, das der Browser
      // wieder per Scroll Anchoring ausglich (Inhalt -1px, Scrollposition 60 -> 59).
      const offen = h.getBoundingClientRect().height;
      // Ebenfalls ungerundet: scrollHeight liefert ganze Pixel. Bei 1133px ist das Bild
      // 30,7px hoch - gesetzt wurden 31px, der aufgeklappte Zustand war damit 0,3px hoeher
      // als gemessen, und genau diese Differenz fehlte dem Ausgleich.
      const untertitel = sub.getBoundingClientRect().height;
      h.classList.add('header-compact');
      const kompakt = h.getBoundingClientRect().height;
      if (!warKompakt) h.classList.remove('header-compact');
      this.einklappSprung = Math.max(0, offen - kompakt);
      h.style.setProperty('--untertitel-h', untertitel + 'px');
      h.style.setProperty('--untertitel-platz', this.einklappSprung + 'px');
      void h.offsetHeight;
      h.classList.remove('kopf-messung');
      document.documentElement.classList.remove('kopf-messung-aktiv');
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Kompakter Header (Untertitel klappt zusammen): eigene Klasse mit KLEINER Schwelle.
      // Dawns 'scrolled-past-header' unten greift erst, wenn man an der gesamten
      // Header-Unterkante vorbei ist — das wäre viel zu spät.
      // ZWEI Schwellen statt einer (Hysterese). Mit einer einzigen Schwelle zittert der
      // Untertitel auf kurzen Seiten und niedrigen Fenstern (z. B. 1440x900):
      // Einklappen macht die Seite ~44px kuerzer, der Browser klemmt scrollTop dadurch
      // wieder unter die Schwelle, der Untertitel klappt auf, die Seite wird laenger,
      // scrollTop steigt — und das Spiel beginnt von vorn.
      // Mit 40 zum Einklappen und 10 zum Aufklappen liegt zwischen beiden Zustaenden ein
      // toter Bereich, in dem nichts umschaltet. Die Rueckkopplung reisst damit ab.
      // STILLGELEGT - frueher feste Schwellen:
      //   if (!compact && scrollTop > 40) add  /  else if (compact && scrollTop < 10) remove
      // Seit der Inhalt beim Einklappen stehen bleibt (base.css, KOPFZEILE OHNE
      // RUECKKOPPLUNG), gibt es keine Schleife mehr, die eine Hysterese brechen muesste. Die
      // Schwellen richten sich jetzt nach dem gemessenen Hoehensprung:
      //   einklappen, sobald man mindestens um ihn gescrollt hat - dann liegt der Inhalt
      //   bereits unter der Kopfzeile, und beim Schrumpfen entsteht keine Luecke darunter;
      //   aufklappen 8px darunter - ein kleiner Puffer gegen das Nachfedern beim Wischen.
      const sprung = this.einklappSprung || 40;
      const compact = this.header.classList.contains('header-compact');
      if (!compact && scrollTop > sprung) {
        this.header.classList.add('header-compact');
      } else if (compact && scrollTop < Math.max(0, sprung - 8)) {
        this.header.classList.remove('header-compact');
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
